<template>
    <div class="category-preparation-status-circle" :class="preparationBgClass(color)"></div>
</template>

<script>
    import {preparationBgClass} from "../../../preparation-classes";

    export default {
        name: 'StatusCircle',

        props: {
            color: {
                type: String,
                required: true,
            },
        },

        methods: {
            preparationBgClass,
        },
    }
</script>

<style lang="scss" scoped>
    .category-preparation-status-circle {
        display: block;
        position: absolute;
        width: 40px;
        height: 40px;
        top: -20px;
        right: -20px;
        border: 2px solid #252525;
        border-radius: 50%;
    }
</style>
